import styled from 'styled-components'
import LogoTmovParceiros from '../../../../shared/assets/images/logo_parceiros.svg'

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto max(500px);
  text-align: center;
  height: 100vh;
  & > div {
    height: calc(100% - 64px);
    padding: 32px;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    button {
      width: 300px;
    }
  }
  img.capa {
    width: 100%;
    object-fit: cover;
    height: 100%;
  }
`
export const Header = styled.img.attrs({
  src: LogoTmovParceiros,
  alt: 'Logo tmov parceiros',
})`
  width: 360px;
  height: 60px;
  object-fit: cover;
`

export const Loading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Error = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 32px;
  h4 {
    max-width: 400px;
  }
`
